module.exports = __webpack_public_path__ + "img/oneRed.54feb828.jpg";